var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	18839: {
		fallback: () => (Promise.all([__webpack_require__.e(2124), __webpack_require__.e(3325)]).then(() => (() => (__webpack_require__(82124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	22844: {
		fallback: () => (__webpack_require__.e(3667).then(() => (() => (__webpack_require__(13667))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	27715: {
		fallback: () => (__webpack_require__.e(1036).then(() => (() => (__webpack_require__(21036))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/telemetry",
	},
	45675: {
		fallback: () => (__webpack_require__.e(5031).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	49282: {
		fallback: () => (__webpack_require__.e(3278).then(() => (() => (__webpack_require__(93278))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.15.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	},
	73834: {
		fallback: () => (__webpack_require__.e(1021).then(() => (() => (__webpack_require__(31021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	77299: {
		fallback: () => (Promise.all([__webpack_require__.e(4965), __webpack_require__.e(4458)]).then(() => (() => (__webpack_require__(74965))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.0.15",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	93549: {
		fallback: () => (__webpack_require__.e(861).then(() => (() => (__webpack_require__(70861))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^14.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "uuid",
	},
	54135: {
		fallback: () => (__webpack_require__.e(5031).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	34458: {
		fallback: () => (__webpack_require__.e(5031).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	13325: {
		fallback: () => (__webpack_require__.e(5031).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	10911: {
		fallback: () => (Promise.all([__webpack_require__.e(7944), __webpack_require__.e(4135)]).then(() => (() => (__webpack_require__(67944))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.4.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "qrcode.vue",
	},
	79700: {
		fallback: () => (__webpack_require__.e(5031).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"911": [
		10911
	],
	"3325": [
		13325
	],
	"4135": [
		54135
	],
	"4458": [
		34458
	],
	"9459": [
		18839,
		22844,
		27715,
		45675,
		49282,
		73834,
		77299,
		93549
	],
	"9700": [
		79700
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}